import { useIdentite } from '../auth/identite.js';
import { useTeinte } from './teinte.js';
import { useDesign } from './useDesign.js';
/** Kept mounted on public routes so signing out clears the account's visual identity. */
export function DesignIdentitySync(): null {
  const identity = useIdentite();
  const { design } = useDesign(identity?.compteId ?? null);
  useTeinte(design, identity?.compteId ?? null);
  return null;
}
